import React from 'react';
import PT from 'prop-types';

import { Link, useHistory } from 'react-router-dom';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';
import CloseSVG from 'Components/Admin/assets/CloseSVG';

const Navbar = ({ routes, onClose }) => {
  const history = useHistory();
  const isMobile = useCheckIsMobile();

  const setActiveClass = (linkUrl) => {
    const url = history.location.pathname;
    if (url && url.includes(linkUrl)) return 'form-navbar__link form-navbar__link_active';
    else return 'form-navbar__link';
  };

  return (
    <>
      {isMobile && <div className="form-navbar__overlay" onClick={onClose} />}
      <div className="form-side-bar__block form-navbar">
        {isMobile && (
          <div className="form-navbar__close">
            <span onClick={onClose}><CloseSVG /></span>
          </div>
        )}
        <ul className="form-navbar__list">
          {routes.map((urlItem) => (
            <li key={urlItem.link} className={setActiveClass(urlItem.link)} onClick={onClose}>
              <Link to={urlItem.link}>
                {urlItem.name}
                {urlItem.isRequired && <div className="form-navbar__required">required</div>}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

Navbar.propTypes = {
  routes: PT.arrayOf(PT.object),
  onClose: PT.func,
};

export default Navbar;
